module.exports = __webpack_public_path__ + "img/06_Red-Paper.6e9fe539.png";